"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var pipe_1 = require("../pipe");
var split = function (char) { return function (str) { return str.split(char); }; };
var map = function (fn) { return function (arr) { return arr.map(fn); }; };
var parseIntWithRadix = function (str) { return parseInt(str, 10); };
var parseVersion = pipe_1.default([
    split('.'),
    map(parseIntWithRadix),
    function (_a) {
        var major = _a[0], minor = _a[1], patch = _a[2];
        return ({ major: major, minor: minor, patch: patch });
    }
]);
exports.default = (function (targetVersion) { return function (version) {
    var _a = parseVersion(targetVersion), targetMajor = _a.major, targetMinor = _a.minor;
    var _b = parseVersion(version), major = _b.major, minor = _b.minor;
    return major === targetMajor && minor === targetMinor;
}; });
